<!--
 - Author : wanghongling.
 - Date   : 2019/5/29.
 - File   : popup.通用弹窗
 -->

<template>
  <div>
    <div :class="['popup-wraps', hasMask?'has-mask':'']" :style="{width: width}">
      <span class="popup-wraps-close" @click="close()">
        <i class="iconfont icon-guanbi"></i>
      </span>
      <div class="popup-wraps-title" v-if="title">
        {{title}}
        <span class="theState" v-if="state==='1'">异常</span>
      </div>
      <div class="popup-wraps-content">
        <slot></slot>
      </div>
    </div>
    <div class="pop-mask" v-if="hasMask" @click.stop="close()">
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
      msg: 'hello vue compoent!'
    }
  },
  props: {
    title: {
      type: String,
      default: '最新预警'
    },
    width: {
      type: String,
      default: '300px'
    },
    state: {
      type: String,
      default: '0'
    },
    hasMask: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * 关闭事件
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    close () {
      this.$emit('closeEvent')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../assets/less/color';
  .has-mask{
    .popup-wraps-content{
      max-height: none !important;
    }
  }
  .pop-mask{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
    background: rgba(0, 60, 98, 0.9)!important;
  }
  .popup-wraps{
    position: relative;
    border-radius: 10px;
    background: rgba(1,21,36,0.85);
    padding: 15px 20px;
    text-align: left;
    min-width: 382px;
    z-index: 999;
    &-close{
      position: absolute;
      top: 16px;
      right: 15px;
      color: @lightBlue;
      cursor: pointer;
      i{
        font-size: 25px;
      }
    }
    &-close:hover{
      opacity: 0.8;
    }
    &-title{
      font-size: 22px;
      font-weight: 600;
      color: @lightBlue;
      .theState{
        background-color: @orange;
        padding: 0 8px 2px;
        border-radius: 2px;
        color: #fff !important;
        display: inline-block;
        margin-left: 8px;
        font-size: 14px;
      }
    }
    &-content{
      margin: 10px 0;
      max-height: 690px;
      overflow-y:scroll;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup.vue